module.exports = __webpack_public_path__ + "static/SNG2-f5b44578820de2ba48d55e229c2708e9.png";